export const STEPS = {
  USER_ACCOUNT: 'user-account',
  SHIPPING: 'shipping',
  PAYMENT: 'payment'
} as const;
export const steps = Object.values(STEPS);

export default steps;
